import styled from "styled-components";

const LabelContainer = styled.div`
  align-self: center;
  margin: 0 0 5px 0;
  padding: 0;
`;

export default LabelContainer;
